import { DriveFileRenameOutline, Folder } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { PlaylistList__PlaylistFolder } from '../../queries/queries.generated';

export interface PlaylistMenuPlaylistFolderProps {
  /** Set by the menu when this is its first child; this component has no element to take it. */
  autoFocus?: boolean;
  item: PlaylistList__PlaylistFolder;
  onMove: () => void;
  onRename: () => void;
}

export const PlaylistMenuPlaylistFolder = ({
  autoFocus,
  item,
  onMove,
  onRename,
}: PlaylistMenuPlaylistFolderProps) => {
  const { t } = useTranslation();
  return (
    <>
      <MenuItem autoFocus={autoFocus} disabled={!item.canUpdate.value} onClick={onMove}>
        <ListItemIcon>
          <Folder />
        </ListItemIcon>
        <ListItemText>{t('pages.playlists.menu.move_folder')}</ListItemText>
      </MenuItem>
      <MenuItem disabled={!item.canUpdate.value} onClick={onRename}>
        <ListItemIcon>
          <DriveFileRenameOutline />
        </ListItemIcon>
        <ListItemText>{t('pages.playlists.menu.rename_folder')}</ListItemText>
      </MenuItem>
    </>
  );
};
